import { format } from 'date-fns'
import csc from 'country-state-city'
import countries from 'i18n-iso-countries'

export default {
  state: {
    dateFrom: format(new Date(), 'yyyy-MM-dd'),
    dateTo: format(new Date(), 'yyyy-MM-dd'),
    countryOf: '',
    stateOf: '',
    codeOf: '',
    stateValues: [],
    dateFromTerminalLedger: format(new Date(), 'yyyy-MM-dd'),
    dateToTerminalLedger: format(new Date(), 'yyyy-MM-dd')
  },
  getters: {
    getDates (state) {
      return [format(new Date(state.dateFrom), 'dd-MM-yyyy'), format(new Date(state.dateTo), 'dd-MM-yyyy')]
    },
    getDatesFormatted (state) {
      return [format(new Date(state.dateFrom), 'do MMM yy'), format(new Date(state.dateTo), 'do MMM yy')]
    },
    getDateTo (state) {
      return state.dateTo
    },
    getDateFrom (state) {
      return state.dateFrom
    },
    getDateToTerminalLedger (state) {
      return state.dateToTerminalLedger
    },
    getDateFromTerminalLedger (state) {
      return state.dateFromTerminalLedger
    }
  },
  mutations: {
    setDateFrom (state, dateFrom) {
      state.dateFrom = dateFrom
    },

    setDateTo (state, dateTo) {
      state.dateTo = dateTo
    },

    setDateFromTerminalLedger (state, dateFrom) {
      state.dateFromTerminalLedger = dateFrom
    },

    setDateToTerminalLedger (state, dateTo) {
      state.dateToTerminalLedger = dateTo
    },

    setCountryOf (state, countryOf) {
      const oldStates = countries.alpha3ToAlpha2(`${countryOf}`)
      const states = csc.getStatesOfCountry(oldStates)
      state.countryOf = countryOf
      state.stateValues = states
    },

    setStateOf (state, stateOf) {
      state.stateOf = stateOf
    },

    setCodeOf (state, codeOf) {
      state.codeOf = codeOf
    },

    setStateValues (state, stateValues) {
      state.stateValues = stateValues
    }
  },
  actions: {
    setDateTo (context, dateTo) {
      context.commit('setDateTo', dateTo)
    },
    setDateFrom (context, dateFrom) {
      context.commit('setDateFrom', dateFrom)
    },
    setDateToTerminalLedger (context, dateToTerminalLedger) {
      context.commit('setDateToTerminalLedger', dateToTerminalLedger)
    },
    setDateFromTerminalLedger (context, dateFromTerminalLedger) {
      context.commit('setDateFromTerminalLedger', dateFromTerminalLedger)
    },
    setDates (context, { start, end }) {
      context.commit('setDateFrom', start)
      context.commit('setDateTo', end)
      // context.dispatch('fetchMeetings')
      // context.dispatch('clearSelections')
    },
    setDatesTerminalLedger (context, { start, end }) {
      context.commit('setDateFromTerminalLedger', start)
      context.commit('setDateToTerminalLedger', end)
      // context.dispatch('fetchMeetings')
      // context.dispatch('clearSelections')
    },
    setCountryOf (context, countryOf) {
      const newCountry = countries.alpha2ToAlpha3(`${countryOf}`)
      if (newCountry === context.state.countryOf) {
        return
      }
      context.commit('setSelectedMeeting', null)
      context.commit('setSelectedRace', null)
      context.commit('setSelectedRunner', null)
      context.commit('setSelectedBookie', null)
      context.commit('setSelectedState', null)
      context.commit('setSelectedCountry', newCountry)
      context.commit('setCountryOf', newCountry)
      // context.dispatch('fetchAllRaces')
      context.commit('updateAllRaces', true)
      // context.dispatch('fetchStateValues');
      // context.dispatch('fetchRaces');
    },

    setStateOf (context, stateOf) {
      context.commit('setSelectedMeeting', null)
      context.commit('setSelectedRace', null)
      context.commit('setSelectedRunner', null)
      context.commit('setSelectedBookie', null)
      context.commit('setSelectedState', stateOf)
      context.commit('setStateOf', stateOf)
      // context.dispatch('fetchAllRaces')
      // context.dispatch('fetchRaces');
    },

    setCodeOf (context, codeOf) {
      context.commit('setSelectedMeeting', null)
      context.commit('setSelectedRace', null)
      context.commit('setSelectedRunner', null)
      context.commit('setSelectedBookie', null)
      context.commit('setSelectedCode', codeOf)
      context.commit('setCodeOf', codeOf)
      // context.dispatch('fetchAllRaces')
      context.commit('updateAllRaces', true)
      // context.dispatch('fetchStateValues');
      // context.dispatch('fetchRaces');
    },

    search (context) {
      setTimeout(() => {
        context.dispatch('clearSelections')
        context.commit('updateAllRaces', true)
        context.commit('updateNoRacesAvail', false)
        context.dispatch('fetchMeetings')
        // context.dispatch('fetchAllRaces')
        // context.dispatch('fetchBookieBets')
        context.dispatch('fetchAllBookies')
        context.dispatch('fetchBookieRace')
        // context.dispatch('fetchRacesDated')
      }, 100)
    },
    searchOverView (context) {
      setTimeout(() => {
        context.dispatch('clearSelections')
        context.commit('updateAllRaces', true)
        context.commit('updateNoRacesAvail', false)
        context.dispatch('fetchMeetings')
        context.dispatch('fetchAllBookies')
        context.dispatch('fetchBookieRace')
        context.dispatch('fetchBookieBetsDated')
        context.dispatch('fetchBookieBets')
      }, 100)
    }
  }
}
